import cx, { type ClassValue } from 'clsx';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import '@fortawesome/fontawesome-svg-core/styles.css';

// Fix for rendering in Content Studio Editmode and CLS on page load
import { config } from '@fortawesome/fontawesome-svg-core/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type FontAwesomeIconWrapperProps = Omit<FontAwesomeIconProps, 'className'> & {
	className?: ClassValue;
};

config.autoAddCss = false;

export function FontAwesomeIconWrapper({
	className,
	...otherProps
}: FontAwesomeIconWrapperProps): JSX.Element {
	return (
		<FontAwesomeIcon {...otherProps} className={cx(className)}/>
	);
}
